module.exports = __webpack_public_path__ + "img/vote-9.7519014e.png";